import styled from "styled-components";

const CategoriesPageStyled = styled.div`

`;

export default CategoriesPageStyled;